var config = require('../config.js')
module.exports = {
  computeDiscount: config.host + '/tktbc/api/v1/showSeat/getShowSeat/c', //计算优惠
  computeDiscountRetail: config.host + '/tktbc/api/v1/cshow/retail/getShowSeat/c', //计算优惠
  getOrderShowSeat: config.host + '/tktbc/api/v1/showSeat/getOrderShowSeat/c', //计算优惠 套票组合
  getOrderSeatId: config.host + '/tktbc/api/v1/showSeat/getOrderSeatId/c', //根据座位获取座位ID
  getSeatList: config.host + '/tktbc/api/v1/showSeat/list/c', //获取场次下的座位信息
  getSubSeatInfoApi: config.host + '/tktbc/api/v1/showSeat/list/subSeatInfo/v2/c', // 底图信息
  getNewShowSeatList: config.host + '/tktbc/api/v1/showSeat/statusList/c', // 新写获取场次下的座位信息
  // getNewShowSeatList: config.host + '/tktbc/api/v1/showSeat/onSale/c', // 新写获取场次下的座位信息
  getShowSeatInfo: config.host + '/tktbc/api/v1/showSeat/list/showSeatInfo/c', //获取场次下的座位信息
  getSubSeatInfo: config.host + '/tktbc/api/v1/showSeat/list/subSeatInfo/c', //获取场次下可售座位信息

  getShowSeatInfoNew: config.host + '/tktbc/api/v1/showSeat/getShowSeatInfo/c', // 新写获取场次下的座位信息

  getSeatBaseInfoV3:config.host + '/tktbc/api/v1/showSeat/getSeatBaseInfoV3/c',
  // getSeatBaseInfoV3:'/localtktbc/api/v1/showSeat/getSeatBaseInfoV3/c',
  getSeatStatusV3:config.host + '/tktbc/api/v1/showSeat/getSeatStatusV3/c',
  // getSeatStatusV3:'/localtktbc/api/v1/showSeat/getSeatStatusV3/c',
  
}